export const PublicConstants = {
    ReCaptchaProtectedAction: {
        // Extra actions can be added here for future reCAPTCHA requirements.
        Login: 'login'
    },
    SuperUser: {
        SuperUserPrefix: 'admin:'
    }
};
